import render from '../utils/render';

/**
 * Copyright template
 * @returns {null|Element}
 */
export default () => render('<div class="gc-copyright">Made with GuideChimp</div>').element;
